import React from 'react';

const CheckIcon = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.739 2.72088C18.1582 3.14007 18.1582 3.8197 17.739 4.23889L6.38432 15.5936L1.01849 10.2278C0.599305 9.80858 0.599305 9.12895 1.01849 8.70976C1.43768 8.29058 2.11731 8.29058 2.53649 8.70976L6.38432 12.5576L16.221 2.72088C16.6402 2.3017 17.3198 2.3017 17.739 2.72088Z"
      fill="#27B0E0"
    />
  </svg>
);

export default CheckIcon;
